// Sync `.apolorules` from disk → Worker `code_sessions.rules_yaml` so injected
// rules (including LEARNED block) apply on the next agent turn without reopen.

import { apiUrl } from './apiBase.js';
import { getStoredToken } from './api.js';
import { hasElectronBridge } from './electronBridge.js';

export async function putSessionRulesYaml(sessionId, yaml) {
  if (!sessionId) return { ok: false, error: 'sessionId required' };
  const token = getStoredToken();
  try {
    const res = await fetch(apiUrl(`/api/code-ide/sessions/${sessionId}/rules`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ rules_yaml: yaml || null }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      return { ok: false, error: body?.error || `HTTP ${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e?.message || String(e) };
  }
}

/** Read `.apolorules` from worktree and PUT to the session (best-effort). */
export async function syncApoloRulesToSession(sessionId, root) {
  if (!sessionId || !root || !hasElectronBridge()) {
    return { ok: false, error: 'Bridge ou sessão ausente' };
  }
  const path = `${root}/.apolorules`;
  const read = await window.apolo.apolorules.read({ path });
  if (!read?.ok || typeof read.content !== 'string') {
    return { ok: false, error: read?.error || 'Arquivo .apolorules não encontrado' };
  }
  return putSessionRulesYaml(sessionId, read.content);
}
